/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-09-12 13:07:15 */

const Keys = { headline: 'headline', buttonText: 'buttonText' }; export default Keys;